import { render, staticRenderFns } from "./CreateGroupClassDialog.vue?vue&type=template&id=53ddf89e"
import script from "./CreateGroupClassDialog.vue?vue&type=script&lang=js"
export * from "./CreateGroupClassDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports